import React, { useState } from "react";
import HomeCarousel from "../customer/Components/Carousel/HomeCarousel";
import { homeCarouselData } from "../customer/Components/Carousel/HomeCaroselData";
import HomeProductSection from "../customer/Components/Home/HomeProductSection";
import { sareePage1 } from "../Data/Saree/page1";
import { dressPage1 } from "../Data/dress/page1";
import { gounsPage1 } from "../Data/Gouns/gouns";
import { kurtaPage1 } from "../Data/Kurta/kurta";
import { mensShoesPage1 } from "../Data/shoes";
import { mens_kurta } from "../Data/Men/men_kurta";
import { lengha_page1 } from "../Data/Women/LenghaCholi";
import ShopebyCategories from "./ShopebyCategories";
import KeenSlider from "./KeenSlider";
import BrandLogo from "./BrandLogo";
import FrameImg from "./FrameImg";
import FeaturesSection from "./Facility";
import CustomerReviews from "./CustomerReviews";
import CustomerReviewsSection from "./CustomerReviews/CustomerReviewsSection";
import WelcomeSection from "./CustomerReviews/WelcomeSection";
import BestSallers from "./BestSallers";
import Sales from "./Sales";
import WedingCollection from "./WedingCollection";
import FlowerRecycling from "./FlowerRecycling";
import BrandLogocopy from "./BrandLogocopy";
import ReviewSlider from "./CutomerReview";
import App from "./CraousalApp";
import Corevitus from "./Corevitus";
import SocialMedia from "./SocialMedia";
import SiliderImgWithpress from "./SiliderImgWithpress";
import HonorRecognitionSection from "./Presidant";
import Speeach from "./Speach";
import Exprincevd from "./Exprincevd";
import SidebarCart from "./SidebarCart";
import CartModal from "./CartModel";
import ProudlyBacked from "./ProudlyBacked";
import HomeProductSectionAll from "../customer/Components/Home/HomeProductSectionAll";
import HomeProductSectionSticks from "../customer/Components/Home/HomeProductSectionSticks";
const Homepage = () => {
  const [isCartOpen, setCartOpen] = useState(false);

  const toggleCart = () => {
    setCartOpen(!isCartOpen);
  };
  return (
    <div className="">
      <HomeCarousel images={homeCarouselData} />
      {/* <App/> */}
      <div className="space-y-10 ">
        <HomeProductSectionAll
          data={dressPage1}
          section={"Our Best Sellers"}
          paragraph={
            "Customers Love Brought These Products on The Top Of The List"
          }
        />
        {/* <BestSallers data={sareePage1} section={"Saree"} /> */}
        <ShopebyCategories />
        <KeenSlider />

        <WedingCollection />
        <HomeProductSectionSticks
        
          section={"INCENSE STICKS"}
          paragraph={"Soothing aroma from temple flowers"}
        />
        <HomeProductSection
     
          section={"INCENSE CONES AND CUPS"}
          paragraph={"Compact cones, rich fragrance"}
        />
        <Corevitus />
    
     
        <ProudlyBacked />
        {/* <FlowerRecycling /> */}

        <Speeach />
        <SiliderImgWithpress />
        {/* <HonorRecognitionSection/> */}
      
        <Exprincevd />
        <SidebarCart isOpen={isCartOpen} onClose={toggleCart} />
           <BrandLogocopy />
            <ReviewSlider />
        {/* <SocialMedia /> */}
        {/* <HomeProductSection data={mensPantsPage1} section={"Men's Pants"} /> */}
      </div>
    </div>
  );
  ;
};

export default Homepage;
